const IS_INFLUENCER_ENABLED = true

export default function isInfluencerEnabledAppUtil () {
  return IS_INFLUENCER_ENABLED
}
